import React from 'react';
import { signalFunctions } from '../../mock';

export default function Ticker() {
  const loop = [...signalFunctions, ...signalFunctions, ...signalFunctions];
  return (
    <div className="border-y border-white/10 bg-[#0F1C40] text-[#F1EDE4] py-5 overflow-hidden">
      <div className="flex items-center gap-6 px-6 lg:px-10 mb-3 text-[10px] font-mono uppercase tracking-widest text-[#4ECDC4]">
        <span className="w-6 h-px bg-[#4ECDC4]" />
        <span>Built for B2B · Powered by AI</span>
        <span className="text-white/40">·</span>
        <span>Intent signals → scored pipeline, in real time</span>
      </div>
      <div className="flex whitespace-nowrap ticker-track">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-6 px-6">
            <span className="text-2xl lg:text-3xl font-serif italic text-white/70">Signal: <span className="text-[#F1EDE4]">{t}</span></span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#4ECDC4]" />
          </div>
        ))}
      </div>
    </div>
  );
}
